import { Col, Form, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { CheckboxGroupButtons } from '@/components/_common';
import {
  QuestReportType,
  QuestSituationOptions,
} from '@/core/domain/questReport/Reports/WorkOrder/WorkOrder.types';

const ReportWorkOrderSituationField: React.FC = () => {
  const intl = useIntl();
  const { Title } = Typography;

  return (
    <Col sm={24}>
      <Title level={5}>
        {intl.formatMessage({
          id: 'movementWorkOrdersReport.form.situation',
        })}
      </Title>

      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const reportType = getFieldValue('reportType');

          const situationOptions = [
            {
              label: intl.formatMessage({
                id: 'movementWorkOrdersReport.form.situation.open',
              }),
              value: QuestSituationOptions.open,
            },
            {
              label: intl.formatMessage({
                id: 'movementWorkOrdersReport.form.situation.authorized',
              }),
              value: QuestSituationOptions.authorized,
            },
            {
              label: intl.formatMessage({
                id: 'movementWorkOrdersReport.form.situation.closed',
              }),
              value: QuestSituationOptions.closed,
              style: {
                display:
                  reportType === QuestReportType.partStatus ? 'none' : '',
              },
            },
            {
              label: intl.formatMessage({
                id: 'movementWorkOrdersReport.form.situation.canceled',
              }),
              value: QuestSituationOptions.canceled,
              style: {
                display:
                  reportType === QuestReportType.partStatus ? 'none' : '',
              },
            },
          ];

          return (
            <>
              <Form.Item
                name="situation"
                initialValue={[QuestSituationOptions.authorized]}
                noStyle
              >
                <CheckboxGroupButtons options={situationOptions} />
              </Form.Item>
            </>
          );
        }}
      </Form.Item>
    </Col>
  );
};

export default ReportWorkOrderSituationField;
